import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const FieldErrorsDefaultProps = {
  ...ClassNameDefaultProps,
  context: null,
  icon: null,
  id: null,
  name: '',
};

export const FieldErrorsPropTypes = {
  ...ClassNamePropTypes,
  context: PropTypes.string,
  errors: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  ).isRequired,
  icon: PropTypes.element,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
};
